<table [dataSource]="dataSource" class="mat-elevation-z8" mat-table matSort style="width: 100%">
	<ng-container *ngFor="let row of displayedColumns; let i = index" matColumnDef="{{ row }}">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon
				*ngIf="tableIcons.length > 0 && tableIcons[i].length > 0"
				class="primary-light-color"
				style="vertical-align: bottom"
			>
				{{ tableIcons[i] }}
			</mat-icon>
			<span class="fs-13 color-black"> {{ tableHeaders[i] }} </span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<div [ngSwitch]="dataType[i]">
				<span *ngSwitchCase="'string'">{{ element[row] }}</span>
				<span *ngSwitchCase="'number'">{{ element[row] }}</span>
				<span *ngSwitchCase="'date'">{{ element[row] | date: 'MM/dd/yyyy' }}</span>
				<span *ngSwitchCase="'currency'">{{ element[row] | currency: 'USD' }}</span>
				<span *ngSwitchCase="'dateTime'">{{ element[row] | date: 'MM/dd/yyy HH:mm:ss' }}</span>
			</div>
		</td>
	</ng-container>

	<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
	<tr
		(click)="route(row)"
		*matRowDef="let row; columns: displayedColumns"
		class="row-hover"
		mat-row
	></tr>
</table>

<mat-paginator
	(page)="emitPageNumber()"
	*ngIf="!isStaticPagination && totalNumberOfRecords > PAGE_SIZE"
	[length]="totalNumberOfRecords"
	[pageSizeOptions]="[PAGE_SIZE]"
	class="mat-elevation-z8"
	showFirstLastButtons
>
</mat-paginator>

<mat-paginator
	*ngIf="isStaticPagination && totalNumberOfRecords > PAGE_SIZE"
	[length]="totalNumberOfRecords"
	[pageSizeOptions]="[PAGE_SIZE]"
	class="mat-elevation-z8"
	showFirstLastButtons
>
</mat-paginator>
